import { CompanyStructure } from "@wingspanhq/users/dist/lib/interfaces";
import { TaxFormType } from "@wingspanhq/payments/dist/interfaces";

export const selectorIsInvalid1099 = (
  companyStructure: CompanyStructure,
  taxFormType: TaxFormType
) => {
  const invalid1099NECStructures = [
    CompanyStructure.CorporationS,
    CompanyStructure.CorporationC,
    CompanyStructure.LLCCorporationC,
    CompanyStructure.LLCCorporationS
  ];

  const validationResults: Record<TaxFormType, boolean> = {
    [TaxFormType.Form1099Nec]:
      invalid1099NECStructures.includes(companyStructure),
    [TaxFormType.Form1099Misc]: false,
    [TaxFormType.T4ASlip]: false
  };

  return validationResults[taxFormType];
};
